import React from 'react';
import { Route, Switch, Redirect } from 'react-router';

import Dashboard from './components/pages/Dashboard';
import DailyPL from './components/pages/DailyPL';
import MonthlyPL from './components/pages/MonthlyPL';
import ShopIntegrations from './components/pages/ShopIntegrations';
import ReviewRequests from './components/pages/ReviewRequests';
import Products from './components/pages/Products';
import ProductKpiAnalysis from './components/pages/ProductKpiAnalysis';
import Purchases from './components/pages/Purchases';
import Expenses from './components/pages/Expenses';
import AdApiAccounts from './components/pages/AdApiAccounts';
import ProductTags from './components/pages/ProductTags';
import Settings from './components/pages/Settings';
import Profile from './components/pages/Profile';
import AdminTenants from './components/pages/AdminTenants';
import AdminUsers from './components/pages/AdminUsers';
import AdminAnalytics from './components/pages/AdminAnalytics';
import AdminSubscriptions from './components/pages/AdminSubscriptions';
import EmailVerification from './components/pages/EmailVerification';

export const routeObjs = [
  {
    exact: true,
    path: '/',
    component: Dashboard,
    label: 'ダッシュボード',
  },
  {
    exact: true,
    path: '/signUp',
    component: Dashboard,
  },
  {
    exact: true,
    path: '/r/:code',
    render: ({ match }) => <Redirect to={`/signUp?ref=${encodeURIComponent(match.params.code)}`} />,
  },
  {
    exact: true,
    path: '/emailVerification',
    component: EmailVerification,
  },
  {
    exact: true,
    path: '/dailyPL',
    component: DailyPL,
    label: '日次損益',
  },
  {
    exact: true,
    path: '/monthlyPL',
    component: MonthlyPL,
    label: '月次損益',
  },
  {
    exact: true,
    path: '/products',
    component: Products,
    label: '商品管理',
  },
  {
    exact: true,
    path: '/productKpiAnalysis',
    component: ProductKpiAnalysis,
    label: '商品KPI分析',
  },
  {
    exact: true,
    path: '/purchases',
    component: Purchases,
    label: '仕入管理',
  },
  {
    exact: true,
    path: '/expenses',
    component: Expenses,
    label: '経費管理',
  },
  {
    exact: true,
    path: '/settings',
    component: Settings,
    label: '設定',
  },
  {
    exact: true,
    path: '/settings/shopIntegrations',
    component: ShopIntegrations,
    label: 'ショップ連携',
  },
  {
    exact: true,
    path: '/reviewRequests',
    component: ReviewRequests,
    label: 'レビュー依頼',
  },
  {
    exact: true,
    path: '/reviewRequests/:sellerId',
    component: ReviewRequests,
    label: 'レビュー依頼',
  },
  {
    exact: true,
    path: '/sellers/:sellerId/reviewRequests',
    component: ReviewRequests,
    label: 'レビュー依頼',
  },
  {
    exact: true,
    path: '/sellers',
    render: ({ location }) => <Redirect to={{ pathname: '/settings/shopIntegrations', search: location.search }} />,
  },
  {
    exact: true,
    path: '/settings/sellers',
    render: ({ location }) => <Redirect to={{ pathname: '/settings/shopIntegrations', search: location.search }} />,
  },
  {
    exact: true,
    path: '/settings/shops',
    render: ({ location }) => <Redirect to={{ pathname: '/settings/shopIntegrations', search: location.search }} />,
  },
  {
    exact: true,
    path: '/settings/adApiAccounts',
    component: AdApiAccounts,
    label: '広告API設定',
  },
  {
    exact: true,
    path: '/settings/productTags',
    component: ProductTags,
    label: '商品タグ設定',
  },
  {
    exact: true,
    path: '/admin',
    render: () => <Redirect to="/admin/tenants" />,
  },
  {
    exact: true,
    path: '/admin/tenants',
    component: AdminTenants,
  },
  {
    exact: true,
    path: '/admin/users',
    component: AdminUsers,
  },
  {
    exact: true,
    path: '/admin/analytics',
    component: AdminAnalytics,
  },
  {
    exact: true,
    path: '/admin/subscriptions',
    component: AdminSubscriptions,
  },
  {
    exact: true,
    path: '/mypage/profile',
    component: Profile,
    label: 'プロフィール',
  },
]

export default function routes (extraProps) {
  return (
    <Switch>
      {
        routeObjs.map((route, i) => {
          const { exact, path, render, props } = route;
          return (
            <Route exact={exact} path={path} render={render || (_ =>
              <route.component {..._} {...extraProps} {...props} />
            )} key={i} />
          );
        })
      }
    </Switch>
  );
};
